const customTrigger = {
  INDEX: '/custom-triggers',
  CREATE: '/custom-triggers/create',
  EDIT: '/custom-triggers/edit',
  ARCHIVE: '/custom-triggers/archive',
}

export default customTrigger
